export const characterSheetStructure = {
    characterName:"Character Name",
    characterData: {
        pluginSnapshot: {
          version: 1,
          hp: {
            current: 0,
            max: 0,
            baseCurrent: 0,
            baseMax: 0,
            hpBuffTotal: 0,
            temp: 0,
            nonLethal: 0,
            delayed: 0,
            delayedMax: 0,
          },
          armorClass: {
            total: 10,
            touch: 10,
            flatFooted: 10,
          },
          savingThrows: {
            fortitude: 0,
            reflex: 0,
            will: 0,
          },
          quickRolls: [],
          buffs: [],
          pointTrackers: [],
        },
        abilities: {
          strength: { score: 10, bonus: 0, damage: 0, drain: 0, burn: 0, wither: 0, permanent:0, modifiedScore: 10, modifiedModifier: 0 },
          dexterity: { score: 10, bonus: 0, damage: 0, drain: 0, burn: 0, wither: 0, permanent:0, modifiedScore: 10, modifiedModifier: 0 },
          constitution: { score: 10, bonus: 0, damage: 0, drain: 0, burn: 0, wither: 0, permanent:0, modifiedScore: 10, modifiedModifier: 0 },
          intelligence: { score: 10, bonus: 0, damage: 0, drain: 0, burn: 0, wither: 0, permanent:0, modifiedScore: 10, modifiedModifier: 0 },
          wisdom: { score: 10, bonus: 0, damage: 0, drain: 0, burn: 0, wither: 0, permanent:0, modifiedScore: 10, modifiedModifier: 0 },
          charisma: { score: 10, bonus: 0, damage: 0, drain: 0, burn: 0, wither: 0, permanent:0, modifiedScore: 10, modifiedModifier: 0 }
        },
        defense: {
          ac: {
            total: 10,
            touch: 10,
            flatFooted: 10,
            armorBonus: 0,
            shieldBonus: 0,
            maxDex: '',
            statModifiers: {
              strength: {modifies: false, multiplier: 1},
              dexterity: {modifies: true, multiplier: 1},
              constitution: {modifies: false, multiplier: 1},
              intelligence: {modifies: false, multiplier: 1},
              wisdom: {modifies: false, multiplier: 1},
              charisma: {modifies: false, multiplier: 1}
            },
            specialAbilityModifiers: {
              strength: {modifies: false, multiplier: 1},
              dexterity: {modifies: false, multiplier: 1},
              constitution: {modifies: false, multiplier: 1},
              intelligence: {modifies: false, multiplier: 1},
              wisdom: {modifies: false, multiplier: 1},
              charisma: {modifies: false, multiplier: 1}
            },
            sizeModifier: 0,
            naturalArmor: 0,
            enhancedNaturalArmor: 0,
            moraleBonus: 0,
            deflection: 0,
            profaneBonus: 0,
            sacredBonus: 0,
            dodgeBonus: 0,
            insightBonus: 0,
            untypedBonus: 0,
            miscModifier: 0,
            touchModifier: 0,
            flatFootedModifier: 0,
            otherModifiers: ''
          },
          hp: {
            max: 0,
            current: 0,
            nonLethal: 0,
            delayed:0,
            delayedMax: 0,
            temp: 0,
          },
          dr: '',
          sr: '',
          saves: {
            fortitude: {
              total: 0,
              baseSave: 0,
              abilityModifiers: {
                strength: {modifies: false, multiplier: 1},
                dexterity: {modifies: false, multiplier: 1},
                constitution: {modifies: true, multiplier: 1},
                intelligence: {modifies: false, multiplier: 1},
                wisdom: {modifies: false, multiplier: 1},
                charisma: {modifies: false, multiplier: 1}
              },
              magicModifier: 0,
              miscModifier: '',
              tempModifier: '',
              otherModifiers: ''
            },
            reflex: {
              total: 0,
              baseSave: 0,
              abilityModifiers: {
                strength: {modifies: false, multiplier: 1},
                dexterity: {modifies: true, multiplier: 1},
                constitution: {modifies: false, multiplier: 1},
                intelligence: {modifies: false, multiplier: 1},
                wisdom: {modifies: false, multiplier: 1},
                charisma: {modifies: false, multiplier: 1}
              },
              magicModifier: 0,
              miscModifier: '',
              tempModifier: '',
              otherModifiers: ''
            },
            will: {
              total: 0,
              baseSave: 0,
              abilityModifiers: {
                strength: {modifies: false, multiplier: 1},
                dexterity: {modifies: false, multiplier: 1},
                constitution: {modifies: false, multiplier: 1},
                intelligence: {modifies: false, multiplier: 1},
                wisdom: {modifies: true, multiplier: 1},
                charisma: {modifies: false, multiplier: 1}
              },
              magicModifier: 0,
              miscModifier: '',
              tempModifier: '',
              otherModifiers: ''
            }
          },
          resist: {
            specific: '',
            elemental: ''
          },
          immune: {
            specific: '',
            effects: ''
          },
          cmd: {
            total: 10,
            statModifiers: {
              strength: {modifies: true, multiplier: 1},
              dexterity: {modifies: true, multiplier: 1},
              constitution: {modifies: false, multiplier: 1},
              intelligence: {modifies: false, multiplier: 1},
              wisdom: {modifies: false, multiplier: 1},
              charisma: {modifies: false, multiplier: 1}
            },
            sizeModifier: 0,
            miscModifiers: '',
            tempModifiers: ''
          }
        },
        offense: {
          initiative: {
            total: 0,
            abilityModifiers: {
              strength: {modifies: false, multiplier: 1},
              dexterity: {modifies: true, multiplier: 1},
              constitution: {modifies: false, multiplier: 1},
              intelligence: {modifies: false, multiplier: 1},
              wisdom: {modifies: false, multiplier: 1},
              charisma: {modifies: false, multiplier: 1}
            },
            miscModifiers: '',
          },
          bab: '',
          conditionalModifiers: '',
          speed: {
            base: 0,
            withArmor: 0,
            fly: '',
            swim: 0,
            climb: 0,
            burrow: 0,
            tempModifiers: ''
          },
          attackBonus: {
            total: 0,
            abilityModifiers: {
              strength: {modifies: true, multiplier: 1},
              dexterity: {modifies: false, multiplier: 1},
              constitution: {modifies: false, multiplier: 1},
              intelligence: {modifies: false, multiplier: 1},
              wisdom: {modifies: false, multiplier: 1},
              charisma: {modifies: false, multiplier: 1}
            },
            enhancementBonus: 0,
            luckBonus: 0,
            moraleBonus: 0,
            profaneBonus: 0,
            sacredBonus: 0,
            insightBonus: 0,
            untypedBonus: 0,
            competenceBonus: 0,
            feat:0,
            sizeModifier: 0,
            miscModifiers: '',
            tempModifiers: '',
            criticalConfirmBonus: 0
          },
          damageBonuses: [{
            name:'',
            showInDetails: false,
            total: 0,
            abilityModifiers: {
              strength: {modifies: true, multiplier: 1},
              dexterity: {modifies: false, multiplier: 1},
              constitution: {modifies: false, multiplier: 1},
              intelligence: {modifies: false, multiplier: 1},
              wisdom: {modifies: false, multiplier: 1},
              charisma: {modifies: false, multiplier: 1}
            },
            dice:'',
            nonMultipliedDamage:'',
            precision:'',
            bonusCriticalDamage:'',
            type:'',
            enhancementBonus: 0,
            luckBonus: 0,
            moraleBonus: 0,
            profaneBonus: 0,
            sacredBonus: 0,
            insightBonus: 0,
            untypedBonus: 0,
            competenceBonus: 0,
            feat:0,
            miscModifiers: '',
            tempModifiers: '',
            notes: '',
          }],
          cmb: {
            total: 0,
            abilityModifiers: {
              strength: {modifies: true, multiplier: 1},
              dexterity: {modifies: false, multiplier: 1},
              constitution: {modifies: false, multiplier: 1},
              intelligence: {modifies: false, multiplier: 1},
              wisdom: {modifies: false, multiplier: 1},
              charisma: {modifies: false, multiplier: 1}
            },
            sizeModifier: 0,
            miscModifiers: '',
            tempModifiers: ''
          },
          cmb2: {
            total: 0,
            abilityModifiers: {
              strength: {modifies: true, multiplier: 1},
              dexterity: {modifies: false, multiplier: 1},
              constitution: {modifies: false, multiplier: 1},
              intelligence: {modifies: false, multiplier: 1},
              wisdom: {modifies: false, multiplier: 1},
              charisma: {modifies: false, multiplier: 1}
            },
            sizeModifier: 0,
            miscModifiers: '',
            tempModifiers: ''
          },
          diceSettings: {
            rerollAttacks: {
              enabled: false,
              attacksToReroll: '',
              rerollTimes: ''
            },
            rerollConfirmations: {
              enabled: false,
              rerollTimes: ''
            },
            missChance: {
              enabled: false,
              missChanceValue: '',
              rerollMissChance: {
                enabled: false,
                attacksToReroll: '',
                rerollTimes: ''
              }
            },
            fortification: {
              enabled: false,
              fortificationValue: '',
              rerollFortification: {
                enabled: false,
                attacksToReroll: '',
                rerollTimes: ''
              }
            },
            ignorePrecision: {
              enabled: false
            }
          },
          attacks: [
            { weapon: 'Unarmed Strike', attackBonus: 0, damageBonusName: '', damage: '', criticalRange: '20', criticalMult: 'x2', type: 'B', notes: '', tempAttackModifiers: '', tempDamageModifiers: '', showInDetails: false, collapsed: false },
            { weapon: 'Short Sword', attackBonus: 0, damageBonusName: '', damage: '', criticalRange: '19-20', criticalMult: 'x2', type: 'P', notes: '', tempAttackModifiers: '', tempDamageModifiers: '', showInDetails: false, collapsed: false }
          ]
        },
        skills: {
          armorCheckPenalty: 0,
          globalModifiers:'',
          skillsNotes: '',
          adventuring: [
            { name: 'Acrobatics', ability: 'dexterity', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: true, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Bluff', ability: 'charisma', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: true, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Climb', ability: 'strength', abilityModifiers: { strength: {modifies: true, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Diplomacy', ability: 'charisma', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: true, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Disable Device*', ability: 'dexterity', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: true, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Disguise', ability: 'charisma', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: true, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Escape Artist', ability: 'dexterity', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: true, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Fly', ability: 'dexterity', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: true, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Heal', ability: 'wisdom', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: true, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Intimidate', ability: 'charisma', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: true, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Arcana)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Dungeoneering)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Local)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Nature)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Planes)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Religion)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (History)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Martial)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Occultism)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Psionics)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Perception', ability: 'wisdom', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: true, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '', inQN: false },
            { name: 'Ride', ability: 'dexterity', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: true, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Sense Motive', ability: 'wisdom', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: true, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '', inQN: false },
            { name: 'Spellcraft*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Stealth', ability: 'dexterity', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: true, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '', inQN: false },
            { name: 'Survival', ability: 'wisdom', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: true, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Swim', ability: 'strength', abilityModifiers: { strength: {modifies: true, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '', inQN: false },
            { name: 'Use Magic Device*', ability: 'charisma', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: true, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Autohypnosis*', ability: 'wisdom', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: true, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '', inQN: false,  }
          ],
          background: [
            { name: 'Appraise', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Artistry', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: true, needsSpecific: true, specific: '' , inQN: false },
            { name: 'Craft', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}},total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: true, needsSpecific: true, specific: '' , inQN: false },
            { name: 'Handle Animal*', ability: 'charisma', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: true, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Engineering)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Geography)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Knowledge (Nobility)*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Linguistics*', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}},total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '' , inQN: false },
            { name: 'Lore', ability: 'intelligence', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: true, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}},total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: true, needsSpecific: true, specific: '' , inQN: false },
            { name: 'Perform', ability: 'charisma', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: true, multiplier: 1}},total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: true, needsSpecific: true, specific: '' , inQN: false },
            { name: 'Profession*', ability: 'wisdom', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: false, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: true, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: true, needsSpecific: true, specific: '' , inQN: false },
            { name: 'Sleight of Hand*', ability: 'dexterity', abilityModifiers: { strength: {modifies: false, multiplier: 1}, dexterity: {modifies: true, multiplier: 1}, constitution: {modifies: false, multiplier: 1}, intelligence: {modifies: false, multiplier: 1}, wisdom: {modifies: false, multiplier: 1}, charisma: {modifies: false, multiplier: 1}}, total: 0, ranks: 0, magic: 0, race_trait: 0, misc: 0, temp:"", notes:"", classSkill: false, canAddMore: false, needsSpecific: false, specific: '', inQN: false,  }
          ]
        },
        feats: {
          sections: [
            {
              name: 'Combat Feats',
              color: '#1976d2',
              feats: [
                { level: 1, name: 'Feat', type: 'Combat', shortDescription: 'Trade attack bonus for damage', longDescription: '' }
              ]
            }
          ]
        },
        specialAbilities: {
          sections: [
            {
              name: 'Class Abilities',
              color: '#4caf50',
              abilities: [
                { level: 1, name: 'Rage', type: 'Su', subsection: 'Class', shortDescription: 'Enter rage for combat bonuses', longDescription: 'This is the long description for the rage ability.' }
              ]
            }
          ]
        },
        spheres: {
          sections: [
            {
              name: 'Spheres',
              color: '#4caf50',
              spheres: [
                { level: 1, name: 'Sphere', type: 'Su', shortDescription: 'Spheres Give Bonuses', longDescription: 'Spheres Give Bonuses. but this time a longer and more detailed description.' }
              ]
            }
          ]
        },
        // Toggleable buffs: { id, name, active, tab, effects: [{ id, amount, category, target, bonusType }] }
        // tab defaults to 'main'; custom tabs are listed in buffTabs (not including 'main').
        buffs: [],
        buffTabs: [],
        // Per-character state for the code-defined common statuses in
        // buffUtilities.COMMON_STATUSES. Effects live in code so they stay
        // current; only activation and remaining time are saved.
        commonStatuses: {
          sickened: { active: false, remainingRounds: null },
          prone: { active: false, remainingRounds: null },
          shaken: { active: false, remainingRounds: null },
          entangled: { active: false, remainingRounds: null },
          grappled: { active: false, remainingRounds: null },
          fatigued: { active: false, remainingRounds: null },
          exhausted: { active: false, remainingRounds: null },
          dazzled: { active: false, remainingRounds: null },
          tanner: { active: false, remainingRounds: null },
          tannerEnhanced: { active: false, remainingRounds: null }
        },
        // Shared duration applied to a common status when it gets checked.
        commonStatusDuration: { value: '', unit: 'rounds' },
        equipment: {//head, headband, eyes, neck, shoulders, chest, body, belt, wrists, hands, rings, feet, trinkets 
          equipmentSlots: {head:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, headband:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, eyes:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, neck:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, shoulders:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, chest:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, body:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, belt:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, wrist:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, hands:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, ring1:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, ring2:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, feet:{item:{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}}, trinkets:{items:[{name:"empty",description:"",weight:0,hasCharges:false,recharges:false,dailyRecharges:0,maxCharges:1,currentCharges:1}]}},
          backpack: [{name:"Main Bag",items:[]}],
          money: {
            cp: 0,
            sp: 0,
            gp: 0,
            pp: 0,
          }
        },
        notes: ``,
        characterDetails:{
            className: '',
            race: '',
            gender: '',
            age: '',
            height: '',
            weight: '',
            hair: '',
            eyes: '',
            languages: '',
            alignment: '',
            deity: '',
            homeland: '',
        }
    },
    stickyWindows:{
        notes:``,
        notesWidth: 250,
        notesHeight: 300,
        // Tracker entries include showAsPip/showAsBar and a hex overlay color.
        pointTrackers:[{
            id:'elevation',
            name:'Elevation',
            value:0,
            max:0,
            default:0,
            showAsPip:true,
            showAsBar:false,
            color:'#0EA5E9',
        }],
        quickDetailsData: {
            tempHP: 0,
            nonLethal: 0,
            delayed: 0,
            ac: 10,
            touch: 10,
            flat: 10,
            cmd: 10,
            acModifiers: '',
            fort: 0,
            ref: 0,
            will: 0,
            atk: 0,
            cmb: 0,
            cmb2: 0,
            damage: '',
            globalAttackModifier:'',
            globalDamageModifier:'',
          },
    },
    
    maneuverTracker: {
        combo:[],
        knownManeuvers: {
            1: [],
            2: [],
            3: [],
            4: [],
            5: [],
            6: [],
            7: [],
            8: [],
            9: []
        },
        readiedManeuvers: {
            1: [],
            2: [],
            3: [],
            4: [],
            5: [],
            6: [],
            7: [],
            8: [],
        },
        specials:{
            encounter:{
                typeList:['utility','mastered','flowing'],
                mastered:[],
                masteredId:Math.random(),
                utility:[],
                utilityId:Math.random(),
                flowing:[],
                flowingId:Math.random()
            },
            daily:{
                typeList:['favorite','perfected','flowing'],
                perfected:[],
                perfectedId:Math.random(),
                favorite:[],
                favoriteId:Math.random(),
                flowing:[],
                flowingId:Math.random()
            }
        },
    },
    spellTracker:{
        spellSections: [
            {
                name: "Main Spell Section",
                isSpontaneous: false,
                spellsKnown: {0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0},
                spellDC: {0: 10, 1: 11, 2: 12, 3: 13, 4: 14, 5: 15, 6: 16, 7: 17, 8: 18, 9: 19},
                spellsPerDay: {0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0},
                bonusSpells: {0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0},
                conditionalModifiers: "",
                specialty: "",
                favorites: {0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 9: []},
                spells: {0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 9: []},
                spellsCast: {0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0}
            }
        ],
        spellPower:{universal:{power:0,criticalChance:0,criticalDamage:50}, fire:{power:0,criticalChance:0,criticalDamage:0}, acid:{power:0,criticalChance:0,criticalDamage:0}, cold:{power:0,criticalChance:0,criticalDamage:0}, electricity:{power:0,criticalChance:0,criticalDamage:0}, positive:{power:0,criticalChance:0,criticalDamage:0}, negative:{power:0,criticalChance:0,criticalDamage:0}}
    },
    psyche:{
      emotionalArray:{Apathy:0,Happiness:0,Fear:0,Anger:0,Disgust:0,Sadness:0,Awe:0},
      soulDamage:0,
      cracked:[],
      powers:[],
      pillars: [
          {
              name: 'body',
              aspects: [
                  { name: 'instinct', scores: [{name:'dexterity',damage:0,cracked:false},{name:'wisdom',damage:0,cracked:false}],temp:0,modifier:0},
                  { name: 'resilience', scores: [{name:'constitution',damage:0,cracked:false},{name:'charisma',damage:0,cracked:false}],temp:0,modifier:0},
                  { name: 'dominance', scores: [{name:'strength',damage:0,cracked:false},{name:'intelligence',damage:0,cracked:false}],temp:0,modifier:0},
              ]
          },
          {
              name: 'mind',
              aspects: [
                  { name: 'intellect', scores: [{name:'strength',damage:0,cracked:false},{name:'intelligence',damage:0,cracked:false}],temp:0,modifier:0},
                  { name: 'knowledge', scores: [{name:'constitution',damage:0,cracked:false},{name:'wisdom',damage:0,cracked:false}],temp:0,modifier:0},
                  { name: 'imagination', scores: [{name:'dexterity',damage:0,cracked:false},{name:'charisma',damage:0,cracked:false}],temp:0,modifier:0},
              ]
          },
          {
              name: 'soul',
              aspects: [
                  { name: 'faith', scores: [{name:'constitution',damage:0,cracked:false},{name:'intelligence',damage:0,cracked:false}],temp:0,modifier:0},
                  { name: 'integrity', scores: [{name:'strength',damage:0,cracked:false},{name:'charisma',damage:0,cracked:false}],temp:0,modifier:0},
                  { name: 'prudence', scores: [{name:'dexterity',damage:0,cracked:false},{name:'wisdom',damage:0,cracked:false}],temp:0,modifier:0},
              ]
          },
          {
              name: 'identity',
              aspects: [
                  { name: 'ego', scores: [{name:'strength',damage:0,cracked:false},{name:'wisdom',damage:0,cracked:false}],temp:0,modifier:0 },
                  { name: 'attachment', scores: [{name:'constitution',damage:0,cracked:false},{name:'charisma',damage:0,cracked:false}],temp:0,modifier:0 },
                  { name: 'narrative', scores: [{name:'dexterity',damage:0,cracked:false},{name:'intelligence',damage:0,cracked:false}],temp:0,modifier:0 },
              ]
          },
      ],
      spirit:{
          aspects: [
              { name: 'temperance', scores: ['constitution', 'intelligence'],damage:0,temp:0,expended:0,modifier:0, scoreModifier:0 },
              { name: 'unity', scores: ['dexterity', 'wisdom'], damage:0,temp:0,expended:0,modifier:0, scoreModifier:0 },
              { name: 'passion', scores: ['strength', 'charisma'], damage:0,temp:0,expended:0,modifier:0, scoreModifier:0 }
          ]
      },
    },

}